













import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent } from '@nuxtjs/composition-api';

import type { InformationPleats } from '~/diptyqueTheme/types/components';

export default defineComponent({
  name: 'VaimoInformationPleats',
  components: {
    InformationPleat: () =>
      import(
        '@/diptyqueTheme/components/molecules/InformationPleat/InformationPleat.vue'
      )
  },
  props: {
    pleats: {
      required: true,
      type: Array as PropType<InformationPleats>
    },
    skipLastBorder: {
      type: Boolean,
      default: true
    }
  },
  emits: ['onPleatClick'],
  setup(props, { emit }) {
    const onPleatClick = (pleat) => {
      emit('onPleatClick', pleat);
    };

    const filteredPleats = computed(() =>
      props.pleats.filter((pleat) => pleat.value)
    );

    return {
      filteredPleats,
      onPleatClick
    };
  }
});
